import { Component, ViewChild } from '@angular/core';
import {
  ProjectsList,
  Projects,
  IProject,
  Skills,
} from '../../../_data/projects';
import { NgxMasonryComponent } from 'ngx-masonry';

enum sortList {
  featured = 'Featured',
  appreciated = 'Most Appreciated',
  viewed = 'Most Viewed',
  recent = 'Most Recent',
}

@Component({
  selector: 'app-portfolio-list',
  templateUrl: './portfolio-list.component.html',
  styleUrls: [
    './portfolio-list.component.scss',
    '../preview/portfolio-preview.component.scss',
  ],
})
export class PortfolioListComponent {
  // Masonry
  @ViewChild(NgxMasonryComponent) private Masonry;

  projects: IProject[] = [];
  skillsList = [
    {
      title: 'All',
      active: true,
    },
  ];
  skill = this.skillsList[0].title;
  sortList = [sortList.featured, sortList.appreciated, sortList.recent];
  sortKeys = ['featured', 'likes', 'year'];
  sortCondition = this.sortKeys[0];
  updateMasonryLayout = false;

  constructor() {
    for (const key in Skills) {
      if (Skills.hasOwnProperty(key)) {
        this.skillsList.push({ title: Skills[key], active: false });
      }
    }

    // Add disabled prop
    ProjectsList.forEach((p, index) => {
      setTimeout(() => {
        p.disabled = true;
        this.projects.push(p);
      }, 100 * index);
    });
  }

  resetProjects() {
    this.projects.length = 0;
    this.projects = [...Projects];
  }

  saveResults() {
    ProjectsList.length = 0;
    this.projects.forEach((p) => {
      ProjectsList.push(p);
    });
  }

  sort(item) {
    // console.warn(this.projects);
    this.projects.sort((a, b) => {
      const nameA = a[item];
      const nameB = b[item];
      if (nameA > nameB) {
        return -1;
      }
      if (nameA < nameB) {
        return 1;
      }
      return 0;
    });
  }

  sortBySkill(skill) {
    this.skill = skill;
    this.resetProjects();
    // Filtering
    if (skill !== 'All') {
      this.projects.forEach((p) => {
        p.disabled = false;
        p.skills.forEach((s) => {
          if (s === skill) {
            p.disabled = true;
          }
        });
      });

      this.sort(this.sortCondition);
      this.sort('disabled');

      this.projects = this.projects.filter((p) => {
        return true;
      });
    } else {
      this.projects.forEach((p) => {
        p.disabled = true;
      });

      this.sort(this.sortCondition);

      this.projects = this.projects.filter((p) => {
        return true;
      });
    }
    this.skillsList.forEach((s) => {
      if (s.title === skill) {
        s.active = true;
      } else {
        s.active = false;
      }
    });
    // Save results
    this.saveResults();
    this.updateLayout();
  }

  showAll() {
    this.resetProjects();
    // Save results
    this.saveResults();
  }

  updateLayout() {
    this.reloadItems();
    this.updateMasonryLayout = !this.updateMasonryLayout;
  }

  reloadItems() {
    setTimeout(() => {
      this.Masonry._msnry.reloadItems();
      this.Masonry._msnry.layout();
    });
  }

  sortBy(condition) {
    switch (condition) {
      case sortList.featured:
        // Sort by Featured
        this.sortCondition = this.sortKeys[0];
        this.sortBySkill(this.skill);
        break;
      case sortList.appreciated:
        // Sort by Likes
        this.sortCondition = this.sortKeys[1];
        this.sortBySkill(this.skill);
        break;
      case sortList.recent:
        // Sort by Year
        this.sortCondition = this.sortKeys[2];
        this.sortBySkill(this.skill);
        break;
      default:
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/portfolio/portfolio-list/portfolio-list.component.ts